function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import debounce from 'lodash.debounce';
import { yieldToMain } from '../biotrust/utils';
import '../../styles/sections/metafield-collection.scss';
$( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
  var $slider, $yotpoReviews, reactivateADA, _reactivateADA, observer;

  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _reactivateADA = function _reactivateADA3() {
            _reactivateADA = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return yieldToMain();

                    case 2:
                      $yotpoReviews.find('*[tabindex]').removeAttr('tabindex');
                      $yotpoReviews.find('*[aria-hidden]').removeAttr('aria-hidden');
                      $yotpoReviews.find('a').attr('tabindex', '-1');
                      $slider.slick('activateADA');

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));
            return _reactivateADA.apply(this, arguments);
          };

          reactivateADA = function _reactivateADA2() {
            return _reactivateADA.apply(this, arguments);
          };

          $slider = $('.product_homepage_slider').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            }, {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }, {
              breakpoint: 480,
              settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2,
                slidesToScroll: 2
              }
            } // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
            ]
          });
          _context2.next = 5;
          return yieldToMain();

        case 5:
          // remove tabindex, aria-hidden from yotpo elements and let slick slider set them
          $yotpoReviews = $slider.find('[data-product-id].yotpo.bottomLine');
          observer = new MutationObserver(debounce(reactivateADA, 300));
          $yotpoReviews.each(function (idx, elem) {
            observer.observe(elem, {
              childList: true,
              subtree: true
            });
          }); // execute immediately in case yotpo loads before MutationObserver

          _context2.next = 10;
          return reactivateADA();

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})));